<div class="ai-admin-shell">
    <!-- Header con tabs -->
    <div class="ai-admin-shell__header">
        <div class="ai-admin-shell__tabs">
            <button
                *ngFor="let tab of tabs"
                [class.active]="currentTab === tab.id"
                (click)="selectTab(tab.id)"
                class="ai-admin-shell__tab-btn"
            >
                <span class="ai-admin-shell__tab-icon">{{ tab.icon }}</span>
                <span class="ai-admin-shell__tab-label">{{ tab.label }}</span>
            </button>
        </div>
    </div>

    <!-- Contenido de las rutas hijas -->
    <div class="ai-admin-shell__content">
        <router-outlet></router-outlet>
    </div>
</div>
